import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {debounceTime} from 'rxjs/operators';
import {Observable, Subject, Subscription} from 'rxjs';
import {FormControl, FormGroup} from '@angular/forms';
import {Storage} from '@ionic/storage';
import {ErrorHandlingService} from '../../provider/error-handling/error-handling.service';
import {SessionDataService} from '../../provider/session-data/session-data.service';
import {Router} from '@angular/router';
import {StorageService} from '../../provider/storage/storage.service';
import {MessagesService} from '../../provider/messages/messages.service';
import {UserService} from "../../provider/user/user.service";

@Component({
	selector: 'app-regisafe-filter',
	templateUrl: './regisafe-filter.component.html',
	styleUrls: ['./regisafe-filter.component.scss'],
})
export class RegisafeFilterComponent implements OnInit, OnChanges {

	@Input() structure: string;
	@Input() searching: boolean;
	@Output() selectedFilter: EventEmitter<any> = new EventEmitter<any>();
	@Output() startSearch = new EventEmitter<any>();

	filterChanged: Subject<string> = new Subject<string>();
	appStructs = [];
	filterForms: any = {};
	filterData: any;
	subscription: Subscription;

	constructor(private storage: Storage,
				private sessionData: SessionDataService,
				public storageService: StorageService,
				private router: Router,
				private errorHandling: ErrorHandlingService,
				private msgService: MessagesService,
				private userService: UserService) {

		try {
			this.appStructs = this.storageService.getLocalStorageAppStructs();
			this.appStructs.forEach((item) => {
				this.filterForms = Object.assign(this.filterForms, {[item]: FormGroup});
			});
		} catch (e) {
			console.log('constructor: ', e);
			// this.router.navigate(['/login']);
		}


		this.filterChanged
			.pipe(debounceTime(250))
			.subscribe((filter: any) => {
				this.selectedFilter.emit(filter)
			});

		this.subscription = this.msgService.getMessages().subscribe((subscription) => {
			if (subscription.message.context === 'filter:reset') {
				this.filterForms = {};
				this.filterData = this.sessionData.filterData;
				try {
					this.appStructs.forEach((form) => {
						this.setFilters(form);
					});
				} catch (e) {
					// this.router.navigate(['/login']);
				}
			}
		});
	}

	ngOnInit() {

		this.filterData = this.sessionData.filterData;
		console.log('this.filterData: ', this.filterData);
		try {
			this.appStructs.forEach((form) => {
				this.setFilters(form);
			});
		} catch (e) {
			this.router.navigate(['/login']);
		}

	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.hasOwnProperty('structure')) {
			if (changes.structure.currentValue) {
				this.onChange(false, changes.structure.currentValue);
			}
		}
	}

	setFilters(structure: any) {

		try {
			const formGroup = {};
			const subformGroup = {};

			this.filterData[structure].formFields.forEach((field) => {
				if (typeof field.name !== 'undefined') {
					formGroup[field.name] = new FormControl({});
				} else if (typeof field.groupname !== 'undefined') {

					field.fields.forEach((subfield) => {
						subformGroup[subfield.name] = new FormControl({});
					});

					formGroup[field.groupname] = new FormGroup(subformGroup);
				}
			});

			this.filterForms[structure] = new FormGroup(formGroup);

			this.filterData[structure].formFields.forEach((field) => {
				if (typeof field.name !== 'undefined') {
					this.filterForms[structure].controls[field.name].setValue(field.value);
				} else if (typeof field.groupname !== 'undefined') {
					field.fields.forEach((subfield) => {

						let value = '';
						if (subfield.type === 'Datum' && subfield.value !== '') {
							value = this.userService.formatDate(subfield.value);
						} else {
							value = subfield.value;
						}
						this.filterForms[structure].controls[field.groupname].controls[subfield.name].setValue(value);
					});
				}
			});

		} catch (e) {
			this.errorHandling.errorMessage('Fehler beim Laden des Filters. ' + e, 'toast');
			this.router.navigate(['/login']);
		}
	}

	onChange(event?, structure?: string) {
		if (!structure) {
			structure = this.structure;
		}

		this.filterChanged.next(this.filterForms[structure].value);
		this.setSearchTextValue(event);
	}

	setSearchTextValue(event) {
		try {
			if (event) {
				const value = event.target.value;
				const name = event.target.name;

				this.storageService.getLocalStorageAppStructs().forEach((form) => {
					if (this.filterForms[form].contains(name)) {
						this.filterForms[form].controls[name].setValue(value);
					}
				});
			}
		} catch (e) {
			console.log('setSearchTextValue error: ', e);
		}
	}

	search() {
		this.startSearch.next(true);
	}

}
